import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SiteDashboardComponent } from '../../shared/components/site-dashboard/site-dashboard';

@Component({
  selector: 'app-q-viewer',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    SiteDashboardComponent
  ],
  templateUrl: './q-viewer.html',
  styleUrl: './q-viewer.scss',
})
export class QViewerComponent {}
